import { Injectable } from '@angular/core';
import { HttpService  } from '../../core/services/http/http.service';
import { CategoriesService } from 'src/app/pages/categories/categories.service';
import { AppState, selectCategoriesState } from 'src/store/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Search } from 'src/store/actions/announcementActions';
@Injectable({
  providedIn: 'root'
})
export class ListviewService {
  getCat: Observable<any>;
  constructor(private store: Store<AppState>, private categoriesServ: CategoriesService, private http: HttpService) {
    this.getCat = this.store.select(selectCategoriesState);
  } 

  getStateOfCategories() {
    this.categoriesServ.dispatchCatAction();
    return this.getCat;
  }
  getCities() {
    return [
      { name: 'Helsinki' },
      { name: 'Turku' },
      { name: 'Tampere' },
      { name: 'Oulu' },
      { name: 'Pori' }
    ]
  }
  searchAnnouncement(query) {
    return this.http.query('get', 'search-announcements?'+ query, {});
  }
  dispatchsearchAnnouncementAction(payload) {
    this.store.dispatch(new Search(payload));
  }
}
